import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion';
export function ServiceTiers() {
  return <section className="py-20 md:py-32 bg-brand-gray" data-id="element-175">
      <div className="container mx-auto px-4 md:px-6" data-id="element-176">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start" data-id="element-177">
          {/* Left Column: Heading Panel */}
          <div className="lg:col-span-5 bg-brand-sky rounded-3xl p-10 md:p-16 flex items-center justify-center text-center lg:text-left lg:sticky lg:top-32" data-id="element-178">
            <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-brand-navy leading-tight" data-id="element-179">
              What's Included
            </h2>
          </div>

          {/* Right Column: Accordion */}
          <div className="lg:col-span-7 bg-brand-white rounded-3xl p-6 md:p-10 shadow-sm border border-brand-sky/30" data-id="element-180">
            <Accordion type="single" defaultValue="item-1" className="w-full space-y-2" data-id="element-181">
              <AccordionItem value="item-1" className="border-b border-brand-navy/10 py-2" data-id="element-182">
                <AccordionTrigger className="font-display font-bold text-xl md:text-2xl text-brand-navy hover:text-brand-aqua transition-colors text-left" data-id="element-183">
                  Exceptional Standard Cleaning Service
                </AccordionTrigger>
                <AccordionContent className="text-brand-navy/80 text-base md:text-lg leading-relaxed pt-4 pb-6" data-id="element-184">
                  Experience a spotless home with our comprehensive cleaning
                  service. We'll sweep, mop, dust, vacuum, and wipe down
                  surfaces in your kitchen, living room, bathroom, dining room,
                  and bedrooms.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-2" className="border-b border-brand-navy/10 py-2" data-id="element-185">
                <AccordionTrigger className="font-display font-bold text-xl md:text-2xl text-brand-navy hover:text-brand-aqua transition-colors text-left" data-id="element-186">
                  Thorough Deep Cleaning Service
                </AccordionTrigger>
                <AccordionContent className="text-brand-navy/80 text-base md:text-lg leading-relaxed pt-4 pb-6" data-id="element-187">
                  Elevate your clean with our Deep Cleaning. In addition to our
                  standard service, we'll scrub surfaces, clean baseboards,
                  walls, and meticulously tackle inside fridge, oven,
                  dishwasher, microwave, and kitchen cabinets. Make your home
                  truly shine.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-3" className="border-b-0 py-2" data-id="element-188">
                <AccordionTrigger className="font-display font-bold text-xl md:text-2xl text-brand-navy hover:text-brand-aqua transition-colors text-left" data-id="element-189">
                  Ultimate Move Out Cleaning Service
                </AccordionTrigger>
                <AccordionContent className="text-brand-navy/80 text-base md:text-lg leading-relaxed pt-4 pb-6" data-id="element-190">
                  Moving out? Leave the cleaning to us. Our Move Out Cleaning
                  service covers more ground and includes scrubbing surfaces,
                  cleaning baseboards, walls, and meticulously addressing inside
                  fridge, oven, dishwasher, microwave, and kitchen cabinets.
                  Ensure a pristine handover.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}